module.exports = __webpack_public_path__ + "71c110c307838348d8dd224fd179f442.pdf";